import type {
  ContingencyPlanDTO,
  ContingencyPlanScenarioDTO
} from '@lmc/ts-common'
import { Text } from '@lmc/ui-kit/src/general'
import dayjs from 'dayjs'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import styled from 'styled-components'

const PersonContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const PersonSubtext = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

export const getContingencyPlanScenarioFields = (
  scenario: ContingencyPlanScenarioDTO,
  residentNominative: string,
  t: (key: string) => string
) => {
  return [
    {
      key: '1',
      label: <Text>{t(supConstants.TRIGGER_FACTOR)}</Text>,
      children: scenario.triggerFactor ? (
        <Text>{scenario.triggerFactor}</Text>
      ) : undefined
    },
    {
      key: '2',
      label: <Text>{t(supConstants.WHAT_SHOULD_HAPPEN)}</Text>,
      children: scenario.actionPlan ? (
        <Text>{scenario.actionPlan}</Text>
      ) : undefined
    },
    {
      key: '3',
      label: <Text>{t(supConstants.WHO_SHOULD_BE_CONTACTED)}</Text>,
      children: scenario.contactPerson ? (
        <Text>{scenario.contactPerson}</Text>
      ) : undefined
    },
    {
      key: '4',
      label: <Text>{t(supConstants.ROLE)}</Text>,
      children: scenario.role ? <Text>{scenario.role}</Text> : undefined
    },
    {
      key: '5',
      label: <Text>{t(supConstants.ANTICIPATORY_MEDS)}</Text>,
      children: scenario.anticipatoryEquipment ? (
        <Text>{scenario.anticipatoryEquipment}</Text>
      ) : undefined
    }
  ].filter((element) => element.children !== undefined)
}

export const getContingencyPlanAdvancedStatementsFields = (
  advancedStatement: { title?: string; description?: string },
  t: (key: string) => string
) => {
  return [
    {
      key: '1',
      label: <Text>{t(supConstants.TITLE)}</Text>,
      children: advancedStatement.title ? (
        <Text>{advancedStatement.title}</Text>
      ) : undefined
    },
    {
      key: '2',
      label: <Text>{t(supConstants.DESCRIPTION)}</Text>,
      children: advancedStatement.description ? (
        <Text>{advancedStatement.description}</Text>
      ) : undefined
    }
  ].filter((element) => element.children !== undefined)
}

export const getContingencyPlanOtherFields = (
  contingencyPlan: ContingencyPlanDTO,
  residentNominative: string,
  t: (key: string) => string
) => {
  return [
    {
      key: '6',
      label: <Text>{t(supConstants.AGREED_WITH_PERSON)}</Text>,
      children: contingencyPlan.agreedWithServiceUser ? (
        <PersonContainer>
          <Text>{contingencyPlan.resident.name}</Text>
          <PersonSubtext level={2}>{residentNominative}</PersonSubtext>
        </PersonContainer>
      ) : (
        <PersonContainer>
          <Text>{contingencyPlan.agreedWithOtherPerson}</Text>
          <PersonSubtext level={2}>
            {t(supConstants.LEGITIMATE_REPRESENTATIVE)}
          </PersonSubtext>
        </PersonContainer>
      )
    },
    {
      key: '7',
      label: <Text>{t(supConstants.DATE_UPDATED)}</Text>,
      children: contingencyPlan.editedOn ? (
        <Text>{dayjs(contingencyPlan.editedOn).format('DD-MM-YYYY')}</Text>
      ) : undefined
    },
    {
      key: '8',
      label: <Text>{t(supConstants.NEXT_REVIEW)}</Text>,
      children: contingencyPlan.nextReviewDate ? (
        <Text>
          {dayjs(contingencyPlan.nextReviewDate).format('DD-MM-YYYY')}
        </Text>
      ) : undefined
    }
  ].filter((element) => element.children !== undefined)
}
